export default "__VITE_ASSET__xKC32hEA__"